import { SelectedFilters } from '@components/AdvisorSearchFilter';
import { isValidHttpUrl } from '@util/validateUrl';
import cloneDeep from 'lodash/cloneDeep';
import { extractDomain, extractSubdomain } from '@util/getURL';

export const searchFilterData = {
  specializations: [
    {
      title: 'Private Office',
      value: 'po',
    },
    {
      title: 'Commercial',
      value: 'com',
    },
    {
      title: 'Development Services',
      value: 'ds',
    },
    {
      title: 'Land and Ranch',
      value: 'ra',
    },
    {
      title: 'Professional Athlete Advisory',
      value: 'paa',
    },
    {
      title: 'Vineyard Advisory',
      value: 'va',
    },
  ],
  languages: [
    {
      title: 'English',
      value: 'en',
    },
    {
      title: 'Chinese',
      value: 'zh',
    },
    {
      title: 'French (CA)',
      value: 'fr-CA',
    },
    {
      title: 'German',
      value: 'de',
    },
    {
      title: 'French (FR)',
      value: 'fr',
    },
    {
      title: 'Hebrew',
      value: 'he',
    },
    {
      title: 'Spanish',
      value: 'sp',
    },
    {
      title: 'Russian',
      value: 'ru',
    },
    {
      title: 'Arabic',
      value: 'ar',
    },
    {
      title: 'Finnish',
      value: 'fi',
    },
  ],
  roles: [
    {
      title: 'Owner',
      value: 'o,lp',
    },
    {
      title: 'Brokerage Manager',
      value: 'bm',
    },
    {
      title: 'Advisor',
      value: 'a',
    },
    {
      title: 'Staff',
      value: 's,ss',
    },
  ],
};

export const expandedLanguagesFilterData = [
  {
    value: 'pa',
    title: 'Punjabi',
  },
  {
    value: 'sr',
    title: 'Serbian',
  },
  {
    value: 'sk',
    title: 'Slovak',
  },
  {
    value: 'tl',
    title: 'Tagalog',
  },
  {
    value: 'ta',
    title: 'Tamil',
  },
  {
    value: 'th',
    title: 'Thai',
  },
  {
    value: 'ur',
    title: 'Urdu',
  },
  {
    value: 'vi',
    title: 'Vietnamese',
  },
  {
    value: 'en',
    title: 'English',
  },
  {
    value: 'fr',
    title: 'French',
  },
  {
    value: 'sp',
    title: 'Spanish',
  },
  {
    value: 'asl',
    title: 'American Sign Language',
  },
  {
    value: 'sq',
    title: 'Albanian',
  },
  {
    value: 'am',
    title: 'Amharic',
  },
  {
    value: 'bn',
    title: 'Bengali',
  },
  {
    value: 'bs',
    title: 'Bosnian',
  },
  {
    value: 'bg',
    title: 'Bulgarian',
  },
  {
    value: 'km',
    title: 'Cambodian',
  },
  {
    value: 'fr-CA',
    title: 'Canadian French',
  },
  {
    value: 'hr',
    title: 'Croatian',
  },
  {
    value: 'prs',
    title: 'Dari',
  },
  {
    value: 'gd',
    title: 'Gaelic',
  },
  {
    value: 'gu',
    title: 'Gujarati',
  },
  {
    value: 'ja',
    title: 'Japanese',
  },
  {
    value: 'ko',
    title: 'Korean',
  },
  {
    value: 'la',
    title: 'Latin',
  },
  {
    value: 'cmn',
    title: 'Mandarin',
  },
  {
    value: 'ga',
    title: 'Irish',
  },
  {
    value: 'lv',
    title: 'Latvian',
  },
  {
    value: 'lt',
    title: 'Lithuanian',
  },
  {
    value: 'mk',
    title: 'Macedonian',
  },
  {
    value: 'mr',
    title: 'Marathi',
  },
  {
    value: 'ne',
    title: 'Nepali',
  },
  {
    value: 'no',
    title: 'Norwegian',
  },
  {
    value: 'ps',
    title: 'Pashto',
  },
  {
    value: 'fa',
    title: 'Persian',
  },
  {
    value: 'pl',
    title: 'Polish',
  },
  {
    value: 'pt',
    title: 'Portuguese',
  },
  {
    value: 'ro',
    title: 'Romanian',
  },
  {
    value: 'ru',
    title: 'Russian',
  },
  {
    value: 'sv',
    title: 'Swedish',
  },
  {
    value: 'zh-tw',
    title: 'Taiwanese',
  },
  {
    value: 'tr',
    title: 'Turkish',
  },
  {
    value: 'uk',
    title: 'Ukrainian',
  },
  {
    value: 'yi',
    title: 'Yiddish',
  },
  {
    value: 'hy',
    title: 'Armenian',
  },
  {
    value: 'yue',
    title: 'Cantonese',
  },
  {
    value: 'zh',
    title: 'Chinese',
  },
  {
    value: 'crp',
    title: 'Creole',
  },
  {
    value: 'cs',
    title: 'Czech',
  },
  {
    value: 'da',
    title: 'Danish',
  },
  {
    value: 'nl',
    title: 'Dutch',
  },
  {
    value: 'fi',
    title: 'Finnish',
  },
  {
    value: 'de',
    title: 'German',
  },
  {
    value: 'el',
    title: 'Greek',
  },
  {
    value: 'he',
    title: 'Hebrew',
  },
  {
    value: 'hu',
    title: 'Hungarian',
  },
  {
    value: 'hi',
    title: 'Hindi',
  },
  {
    value: 'it',
    title: 'Italian',
  },
  {
    value: 'ar',
    title: 'Arabic',
  },
  {
    value: 'cy',
    title: 'Welsh',
  },
  {
    value: 'ti',
    title: 'Tigrinya',
  },
  {
    value: 'af',
    title: 'Afrikaans',
  },
];

// Queries list of properties
export const generateResults = async ({
  sortType,
  offset,
  limit,
  api,
  name,
  shop,
  shops,
  filters,
  searchInputOverride,
}: {
  sortType: { sortKey: string; sortDir: string };
  offset: number;
  limit: number;
  api: any;
  name: string;
  shop?: string;
  shops?: string;
  filters: SelectedFilters;
  searchInputOverride?: boolean;
}) => {
  let params: any = {
    sortKey: sortType.sortKey,
    sortDir: sortType.sortDir,
    offset,
    limit,
  };
  if (filters) {
    if (filters.languages) {
      params = { ...params, languages: filters.languages };
    }
    if (filters.specializations) {
      params = {
        ...params,
        specializations: filters.specializations,
        noteams: 'true',
      };
    }
    if (filters.roles) {
      const noTeamsFlag = filters?.roles?.includes('a') ? 'false' : 'true';
      params = { ...params, positions: filters.roles, noteams: noTeamsFlag };
    }
    if (filters.shopIds) {
      params = { ...params, shops: filters.shopIds };
    }
  }
  if (name) {
    name = encodeURIComponent(name);
    params = { ...params, [searchInputOverride ? 'search' : 'name']: name };
  }

  let searchResults = await api.listAdvisors(params);
  const data = await searchResults;
  return data;
};
/**
 * INFO:
 *  As advisor's have multiple account, and we need to display each account in advisor list,
 *  so we modified the api response of advisor list.
 **/
const mapAdvisorAccountListToAdvisorList = (results, shopIds, shopName) => {
  const tmpArray: any[] = [];
  if (!shopIds && !shopName) {
    results?.forEach((advisor) => {
      if (advisor?.accounts?.length > 1) {
        advisor?.accounts?.forEach((account) => {
          const tmpAdvisor = cloneDeep(advisor);
          tmpAdvisor.accounts = [account];
          tmpArray.push(tmpAdvisor);
        });
      } else {
        tmpArray.push(advisor);
      }
    });
    return tmpArray;
  }
  return results;
};

export const mapResults = (results, shopIds, shopname) => {
  const updatedResults = mapAdvisorAccountListToAdvisorList(results, shopIds, shopname);
  return updatedResults && updatedResults.length > 0
    ? updatedResults.map((r) => {
        let accounts =
          r.accounts?.filter((account) => {
            let { associatedShops } = account;
            return associatedShops?.find(
              (shop) =>
                shop.domain?.toLowerCase() === `${shopname?.toLowerCase()}.evrealestate.com`,
            );
          }) || [];
        if (accounts.length > 0) {
          r.accounts = accounts;
        }
        return {
          image: getImage(r),
          name: getName(r),
          title: getTitle(r),
          phone: checkForSpaces(getPhone(r)),
          licenseNumber: getLicenseNumber(r),
          office: getOffice(r, shopIds),
          urlFacebook: getSocialIcon(r, 'facebook'),
          urlTwitter: getSocialIcon(r, 'twitter'),
          urlLinkedin: getSocialIcon(r, 'linkedin'),
          urlInstagram: getSocialIcon(r, 'instagram'),
          urlYoutube: getSocialIcon(r, 'youtube'),
          urlTiktok: getSocialIcon(r, 'tiktok'),
          urlAdvisor: getUrlAdvisor(r, shopname),
        };
      })
    : [];
};

export const getImage = (object) => {
  return object?.profilePicture
    ? object.profilePicture
    : object.profileThumbnail
    ? object.profileThumbnail
    : object?.teamPicture || '';
};

export const getName = (object) => {
  return object?.type === 'team'
    ? object?.name
    : `${object?.name?.firstName} ${object?.name?.lastName}`;
};

export const getTitle = (object) => {
  return object?.type === 'team'
    ? object?.evTitle || object?.title
    : object?.accounts && object?.accounts?.length > 0
    ? object?.accounts[0]?.title || object?.accounts[0]?.evTitle
    : '';
};
export const getTitleLeadership = (object) => {
  return object?.accounts && object?.accounts?.length > 0
    ? object?.accounts[0]?.title || object?.accounts[0]?.evTitle
    : '';
};

const getPhone = (object) => {
  return object?.type === 'team'
    ? object?.contact?.phone
    : object?.accounts && object?.accounts?.length > 0
    ? object?.accounts[0]?.contact?.phone
    : '';
};

const getLicenseNumber = (object) => {
  if (object?.type === 'team') {
    return object?.stateLicenses && object?.stateLicenses?.length > 0
      ? object?.stateLicenses[0]?.licenseNumber
      : '';
  } else {
    let state = object?.accounts[0]?.stateLicenses[0]?.state || '',
      license = object?.accounts[0]?.stateLicenses[0]?.license || '';
    if (state != '') {
      if (license.startsWith(state)) {
        license = license.replace(state, '');
      }
      state = state + ': ';
    }
    return object?.accounts && object?.accounts?.length > 0
      ? object?.accounts[0]?.stateLicenses && object?.accounts[0]?.stateLicenses?.length > 0
        ? `${state}${license}`
        : ''
      : '';
  }
};

export const getShopUrlUseExternalWebsite = (shop, isAdvisorProfile = false) => {
  let shopUrl = isValidHttpUrl(shop?.domain);
  if (typeof window !== 'undefined' && shop?.useExternalWebsite) {
    let subdomain: any;
    if (isAdvisorProfile) {
      subdomain = extractSubdomain(shop?.url);
    } else {
      const belongsToShopGroup = !!shop.shopGroup?.id;
      subdomain = belongsToShopGroup
        ? shop.shopGroup?.domain?.split('.')?.[0]
        : shop.contact?.website?.split('.')?.[0];
    }

    const currentHost = window.location.host;
    const currentHostSubDomain = extractSubdomain();
    shopUrl = subdomain
      ? shop?.useExternalWebsite || currentHost.includes('vercel.app')
        ? `${window.location.protocol}//${extractDomain(currentHost)}/shops/${subdomain}`
        : `${window.location.protocol}//${subdomain}.${extractDomain(
          currentHost,
          currentHostSubDomain,
        )}`
      : '';
  }
  return shopUrl;
}

export const getOffice = (object: any, shopIds?: string[]) => {
  if (object?.type === 'team') {
    if (object?.associatedShops && object?.associatedShops?.length > 0) {
      if (shopIds && shopIds.length > 0) {
        const shop = object?.associatedShops.find((shop) => shopIds.includes(shop?.shopId));
        const shopName = shop?.name?.toLowerCase();
        const activeShopName =
          shopName.includes('terminated') || shopName.includes('transferred') ? '' : shop?.name;

        return {
          name: activeShopName,
          locationName: shop?.locationName,
          address: shop?.address,
          address2: shop?.address2,
          city: shop?.city,
          state: shop?.state,
          postalCode: shop?.postalCode,
          url: isValidHttpUrl(shop?.domain),
          useExternalWebsite: shop?.useExternalWebsite || false,
        };
      } else {
        const shopName = object?.associatedShops[0]?.name?.toLowerCase();
        const activeShopName =
          shopName?.includes('terminated') || shopName?.includes('transferred')
            ? ''
            : object?.associatedShops[0]?.name;

        return {
          name: activeShopName,
          locationName: object?.associatedShops[0]?.locationName,
          address: object?.associatedShops[0]?.address,
          address2: object?.associatedShops[0]?.address2,
          city: object?.associatedShops[0]?.city,
          state: object?.associatedShops[0]?.state,
          postalCode: object?.associatedShops[0]?.postalCode,
          url: isValidHttpUrl(object?.associatedShops[0]?.domain),
          useExternalWebsite: object?.associatedShops[0]?.useExternalWebsite || false,
        };
      }
    } else {
      const shopName = object?.shop?.toLowerCase();
      const activeShopName =
        shopName?.includes('terminated') || shopName?.includes('transferred') ? '' : object?.shop;

      let shopUrl = '';
      let useExternalWebsite = false;

      // Gets correct shopUrl off of associatedAdvisor accounts
      object?.associatedAdvisors?.some((advisor) =>
        advisor?.accounts?.some((account) =>
          account?.associatedShops?.some((shop) => {
            if (shop?.name?.toLowerCase().trim() === activeShopName?.toLowerCase().trim()) {
              shopUrl = shop?.domain || '';
              useExternalWebsite = shop?.useExternalWebsite || false;
              return true;
            }
            return false;
          }),
        ),
      );

      return {
        name: activeShopName,
        locationName: '',
        address: object?.contact?.address || object?.contact?.street1 || '',
        address2: object?.contact?.address2 || object?.contact?.street2 || '',
        city: object?.contact?.city,
        state: object?.contact?.state,
        postalCode: object?.contact?.postalCode,
        url: isValidHttpUrl(shopUrl),
        useExternalWebsite,
      };
    }
  } else {
    if (
      object?.accounts?.[0]?.associatedShops &&
      object?.accounts[0]?.associatedShops?.length > 0
    ) {
      if (shopIds && shopIds.length > 0) {
        const shop = object?.accounts
          .flatMap((account) => account?.associatedShops || [])
          .find((shop) => shopIds.includes(shop?.shopId));
        return {
          name: shop?.name,
          locationName: shop?.locationName,
          address: shop?.address,
          address2: shop?.address2,
          city: shop?.city,
          state: shop?.state,
          postalCode: shop?.postalCode,
          url: getShopUrlUseExternalWebsite(shop),
          chimeOfficeId: shop?.chimeInfo?.chimeOfficeId,
          useExternalWebsite: shop?.useExternalWebsite || false,
        };
      } else {
        return {
          name: object?.accounts[0]?.associatedShops[0]?.name,
          locationName: object?.accounts[0]?.associatedShops[0]?.locationName,
          address: object?.accounts[0]?.associatedShops[0]?.address,
          address2: object?.accounts[0]?.associatedShops[0]?.address2,
          city: object?.accounts[0]?.associatedShops[0]?.city,
          state: object?.accounts[0]?.associatedShops[0]?.state,
          postalCode: object?.accounts[0]?.associatedShops[0]?.postalCode,
          url: getShopUrlUseExternalWebsite(object?.accounts[0]?.associatedShops[0]),
          chimeOfficeId: object?.accounts[0]?.associatedShops[0]?.chimeInfo?.chimeOfficeId,
          useExternalWebsite: object?.accounts[0]?.associatedShops[0]?.useExternalWebsite || false,
        };
      }
    } else {
      return {
        name: '',
        locationName: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        url: '',
      };
    }
  }
};

const getSocialIconUrl = (socialProfiles, socialIconType) => {
  let url = '';
  if (socialProfiles && socialProfiles?.length > 0) {
    url = socialProfiles.find((icon) => icon?.type === socialIconType)?.url;
  }
  return url;
};

const getSocialIcon = (object, socialIconType) => {
  return object?.type === 'team'
    ? getSocialIconUrl(object?.socialProfiles, socialIconType)
    : object?.accounts && object?.accounts?.length > 0
    ? getSocialIconUrl(object?.accounts[0]?.socialProfiles, socialIconType)
    : '';
};

const getAdvisorBioUrl = (url: string | null, id: string, name: string, userId?: string) => {
  const subdomain = isValidHttpUrl(url);
  if (subdomain != '') {
    return `${subdomain}/our-advisors/${name}/${id}`;
  }
  let tmpUrl = `/our-advisors/${name}/${id}`;
  // Always add userId if it exists to get the correct advisor account
  if (userId) {
    tmpUrl += `?userId=${userId}`;
  }
  return tmpUrl;
};

export const getUrlAdvisor = (object, shopname) => {
  let url;
  if (object?.type === 'team') {
    url = getAdvisorBioUrl(null, object?.teamId, object?.name.replace(/\s+/g, '-').toLowerCase());
  } else {
    url =
      object?.accounts &&
      object?.accounts?.length > 0 &&
      object?.accounts[0]?.associatedShops &&
      object?.accounts[0]?.associatedShops.length > 0
        ? getAdvisorBioUrl(
            null,
            object?.advisorId,
            `${object?.name?.firstName.toLowerCase()}-${object?.name?.lastName.toLowerCase()}`,
            object?.accounts?.[0]?.userId,
          )
        : '';
  }
  //if shopname is not null, then add "/shops/shopname" to the url
  if (shopname) {
    url = `/shops/${shopname}${url}`;
  }
  return url;
};

// a handful of advisors have only spaces in their details, this filters that out
export const checkForSpaces = (item) => {
  if (typeof item === 'string' && item.trim() === '') {
    return '';
  }
  return item;
};

// Get Advisor Details Mapping
export const getAdvisorBioData = (
  data: any,
  shopIds: string[],
  locale: string,
  shopName?: string,
  userId?: string,
) => {
  const mlsIds = data.accounts
    .flatMap((account) => account?.mls?.map((mlsObj) => mlsObj?.mlsId))
    .filter((mlsId) => mlsId)
    .join(',');
  /**
   * INFO:
   *  As HZ using first index of accounts array so,
   *  we need to pick correct account using userId
   */
  if (userId) {
    const resultAccount = data?.accounts?.find((account) => {
      return account?.userId?.toLowerCase() === userId?.toString().toLowerCase();
    });
    if (resultAccount) {
      data.accounts = [resultAccount];
    }
  } else if (shopIds && shopIds.length > 0) {
    // Check if first account in associateShops if it matches the shopIds
    let resultAccount = data?.accounts?.find((account) => {
      const firstShop = account?.associatedShops?.[0];
      return shopIds.includes(firstShop?.shopId);
    });

    // Check all shops if no account has first shop matching the shopId
    if (!resultAccount) {
      resultAccount = data?.accounts?.find((account) =>
        account?.associatedShops?.some((shop) => shopIds.includes(shop?.shopId)),
      );
    }

    if (resultAccount) {
      data.accounts = [resultAccount];
    }
  } else if (shopName) {
    const lowerShopName = shopName.toLowerCase();

    // Check if first account in associateShops matches the shopName
    let resultAccount = data?.accounts?.find((account) => {
      const firstShop = account?.associatedShops?.[0];
      return firstShop?.locationName?.toLowerCase() === lowerShopName;
    });

    if (!resultAccount) {
      // Check all shops if no account has first shop matching the shopName
      resultAccount = data?.accounts?.find((account) =>
        account?.associatedShops?.some(
          (shop) => shop?.locationName?.toLowerCase() === lowerShopName,
        ),
      );
    }

    if (resultAccount) {
      data.accounts = [resultAccount];
    }
  }

  const advisorObj = {
    id: data?.advisorId,
    chimeInfoUserId:
      data?.accounts && data?.accounts.length ? data?.accounts[0]?.chimeInfo?.memberUserId : '',
    chimeInfoTeamMemberId:
      data?.accounts && data?.accounts.length ? data?.accounts[0]?.chimeInfo?.teamMemberId : '',
    pronouns: data?.pronouns,
    profilePicture: data?.profilePicture,
    name: `${data?.name?.firstName} ${data?.name?.lastName}`,
    userId: data?.advisorId,
    listingUserId: data?.accounts?.[0]?.userId,
    mlsIds: mlsIds || '',
    specializations:
      data?.accounts && data?.accounts.length ? data?.accounts[0]?.specializations : '',
    designations: data?.accounts && data?.accounts.length ? data?.accounts[0]?.designations : '',
    languages: data?.accounts && data?.accounts.length ? data?.accounts[0]?.languages : '',
    contact: {
      email:
        data?.accounts && data?.accounts.length
          ? data?.accounts[0]?.contact?.alternativeEmail || data?.accounts[0]?.contact?.email
          : '',
      alternativeEmail:
        data?.accounts && data?.accounts.length ? data?.accounts[0]?.contact?.alternativeEmail : '',
      phone:
        data?.accounts && data?.accounts.length
          ? checkForSpaces(data?.accounts[0]?.contact?.phone)
          : '',
      website: data?.accounts && data?.accounts.length ? data?.accounts[0]?.contact?.website : '',
    },
    associatedShops: getOffice(data, shopIds),
    domain: data?.accounts && data?.accounts.length ? `${data?.accounts[0]?.domain}` : '',
    shopIds: data?.accounts[0]?.associatedShops?.map((item) => item.shopId) || [],
    socialProfiles:
      data?.accounts && data?.accounts.length ? data?.accounts[0]?.socialProfiles : '',
    advisorBio: {
      value:
        data?.accounts && data?.accounts.length && data?.accounts[0].advisorBio.length
          ? data?.accounts[0]?.advisorBio.find((item) => item.language == locale.split('-')[0])
              ?.value ||
            data?.accounts[0]?.advisorBio.find((item) => item.language == 'sp')?.value ||
            data?.accounts[0]?.advisorBio.find((item) => item.language == 'en')?.value ||
            data?.accounts[0]?.advisorBio[0]?.value
          : '',
    },
    advisorRatings:
      data?.accounts && data?.accounts.length ? data?.accounts[0]?.advisorRatings : '',
    title: data?.accounts && data?.accounts.length ? data?.accounts[0]?.title : '',
    evTitle: data?.accounts && data?.accounts.length ? data?.accounts[0]?.evTitle : '',
    positions: data?.accounts && data?.accounts.length ? data?.accounts[0]?.positions : '',
    stateLicenses: data?.accounts && data?.accounts.length ? data?.accounts[0]?.stateLicenses : '',
    personalMediaPhoto:
      data?.accounts && data?.accounts.length ? data?.accounts[0]?.personalMediaPhoto : '',
    personalMediaVideo:
      data?.accounts && data?.accounts.length ? data?.accounts[0]?.personalMediaVideo : '',
  };
  return advisorObj;
};

// Get Team Details Mapping
export const getTeamBioData = (team: any, shopIds?: string[]) => {
  let mlsIds = team.associatedAdvisors
    ?.flatMap((advisor) =>
      advisor.accounts.flatMap((account) => account.mls?.map((mlsObj) => mlsObj.mlsId)),
    )
    .filter((mlsId) => mlsId)
    .join(',');
  mlsIds += ',' + team.mls.flatMap((mls) => mls.mlsId).join(',');

  if (!shopIds && team.shopId) {
    shopIds = [team.shopId];
  }

  const teamObj = {
    id: team.teamId,
    chimeInfoUserId: '0',
    name: team.name,
    userId: team.teamId,
    mlsIds: mlsIds || '',
    languages: team.teamLanguages,
    teamPicture: team.teamPicture,
    contact: {
      email: team.alternativeEmail || team.email || team.contact?.email,
      alternativeEmail: null,
      phone: team.phoneNumbers?.length ? team.phoneNumbers[0] : checkForSpaces(team.contact?.phone),
      website: team.websiteLinks?.length ? team.websiteLinks[0] : team.contact?.website,
    },
    associatedShops: getOffice(team, shopIds),
    shopIds: shopIds,
    socialProfiles: team.socialLinks || team.socialProfiles,
    advisorBio: {
      value: `${team.bio?.length ? team.bio[0].value : ''}`,
    },
    title: team.socialLinks?.length ? team.socialLinks[0]?.title : null,
    evTitle: null,
    stateLicenses: team.licenses || team.stateLicenses,
    associatedAdvisors: team.associatedAdvisors?.map((item) => {
      const title = item.accounts[0].title || 'Advisor';
      return {
        img: item.profileThumbnail || '/assets/textimageplaceholder.png',
        name: `${item.firstName} ${item.lastName}` || 'Name Unavailable',
        description: title || 'Description not available',
        ctaUrl: `/our-advisors/${item.firstName}-${item.lastName}/${item.advisorId}`,
        ctaText: `Meet ${item.firstName}` || 'Meet Advisor',
      };
    }),
    chimeInfo: team.chimeInfo,
    chimeInfoTeamMemberId: team.chimeInfo?.teamId,
    personalMediaPhoto: team.personalMediaPhoto,
    personalMediaVideo: team.personalMediaVideo,
  };
  return teamObj;
};
